<template>
    <div class="">
        <h4 class="form-section__title">
            <span v-for="(item, index) in $root.t('step3.supplementaryQuestions')" :key="index">
                {{ item }} <br />
            </span>
        </h4>
        <!--  Pastimes -->
        <div class="form-section__field">
            <label class="form-label required" :for="prefix + 'Pastimes'">{{ $t('step3.pastime') }}</label>
            <div class="form-field ps-2">
                <div class="form-group p-3 border-start border-primary">
                    <AppInput
                        :name="prefix + 'PhysicianDetails.Title'"
                        :label="$root.t('step3.pastimeAsk')"
                        rules="required|appSelectRequired"
                        class="form-section__field"
                    >
                        <AppSelect
                            :id="prefix + 'pastime'"
                            v-model="additionalDetails.pastimeId"
                            :placeholder="$t('common.defaultSelectionValue')"
                            :options="$optionData.pastimes"
                            key-value="value"
                            key-text="text"
                        />
                    </AppInput>

                    <AppInput
                        class="form-section__field"
                        :name="prefix + 'otherPastimess'"
                        :label="$root.t('step3.pastimeAskText')"
                    >
                        <Input
                            v-model="additionalDetails.otherPastimes"
                            class-name="form-control"
                            auto-complete="nope"
                        />
                    </AppInput>
                </div>
            </div>
        </div>

        <!--  Smoking -->
        <div class="form-section__field">
            <!-- <AppInputCheck
        v-model="additionalDetails.smoking"
        :label="$root.t('step3.smoke')"
        rules="required"
      >
        <div role="radiogroup">
          <div class="form-check form-check-inline">
            <input
              :id="prefix + 'Smoking-yes'"
              v-model="additionalDetails.smoking"
              class="form-check-input"
              type="radio"
              :name="prefix + 'Smoking'"
              :value="true"
              :aria-labelledby="prefix + 'smoke-question'"
            >
            <label
              class="form-check-label"
              :for="prefix + 'Smoking-yes'"
            >{{ $t('common.yesAnswer') }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              :id="prefix + 'Smoking-no'"
              v-model="additionalDetails.smoking"
              class="form-check-input"
              type="radio"
              :name="prefix + 'Smoking'"
              :value="false"
              :aria-labelledby="prefix + 'smoke-question'"
            >
            <label
              class="form-check-label"
              :for="prefix + 'Smoking-no'"
            >{{ $t('common.noAnswer') }}</label>
          </div>
        </div>
      </AppInputCheck> -->
            <!-- Additional form -->
            <div v-if="additionalDetails.smoking" class="form-field ps-2">
                <div class="form-group p-3 border-start border-primary">
                    <!-- Enter Details -->
                    <div class="col-md-12">
                        <AppInput :name="prefix + 'Smoking'" :label="$root.t('step3.smokeAsk')" rules="required">
                            <Input
                                v-model="additionalDetails.smokingAnswerHowMany"
                                class-name="form-control"
                                auto-complete="nope"
                            />
                        </AppInput>
                    </div>
                </div>
            </div>
        </div>

        <!--  Refused Cover -->
        <div class="form-section__field">
            <AppInputCheck
                v-model="additionalDetails.refusedCoverOrAcceptedOnSpecialTerms"
                :label="$root.t('step3.companyInsured')"
                rules="required"
            >
                <div role="radiogroup">
                    <div class="form-check form-check-inline">
                        <input
                            :id="prefix + 'RefusedCoverOrAcceptedOnSpecialTerms-yes'"
                            v-model="additionalDetails.refusedCoverOrAcceptedOnSpecialTerms"
                            class="form-check-input"
                            type="radio"
                            :name="prefix + 'RefusedCoverOrAcceptedOnSpecialTerms'"
                            :value="true"
                            :aria-labelledby="prefix + 'RefusedCoverOrAcceptedOnSpecialTerms-lb'"
                        />
                        <label class="form-check-label" :for="prefix + 'RefusedCoverOrAcceptedOnSpecialTerms-yes'">{{
                            $t('common.yesAnswer')
                        }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            :id="prefix + 'RefusedCoverOrAcceptedOnSpecialTerms-no'"
                            v-model="additionalDetails.refusedCoverOrAcceptedOnSpecialTerms"
                            class="form-check-input"
                            type="radio"
                            :name="prefix + 'RefusedCoverOrAcceptedOnSpecialTerms'"
                            :value="false"
                            :aria-labelledby="prefix + 'RefusedCoverOrAcceptedOnSpecialTerms-lb'"
                        />
                        <label class="form-check-label" :for="prefix + 'RefusedCoverOrAcceptedOnSpecialTerms-no'">{{
                            $t('common.noAnswer')
                        }}</label>
                    </div>
                </div>
            </AppInputCheck>

            <!-- Additional form -->
            <div v-if="additionalDetails.refusedCoverOrAcceptedOnSpecialTerms" class="form-field ps-2">
                <div class="form-group p-3 border-start border-primary">
                    <div class="form-section__field col-md-12">
                        <AppInput
                            :name="prefix + 'additionalDetails.refusedCoverOrAcceptedOnSpecialTermsDate'"
                            :label="$root.t('step3.companyInsuredAskDate')"
                            rules="required"
                        >
                            <AppDatePicker v-model="additionalDetails.refusedCoverOrAcceptedOnSpecialTermsDate" />
                        </AppInput>
                    </div>

                    <!-- Enter Details -->
                    <div class="col-md-12">
                        <AppInput
                            :name="prefix + 'RefusedCoverOrAcceptedOnSpecialTermsDetails'"
                            :label="$root.t('step3.companyInsuredAskDetails')"
                            rules="required"
                        >
                            <Input
                                v-model="additionalDetails.refusedCoverOrAcceptedOnSpecialTermsDetails"
                                class-name="form-control"
                                auto-complete="nope"
                            />
                        </AppInput>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SupplementaryQuestionForm',
    components: {},
    props: {
        additionalDetails: { type: Object, required: true },
        prefix: { type: String, default: '' },
    },
    data() {
        return {}
    },
    methods: {
        pastimeUncheck(form) {
            form.pastimeId = null
            form.otherPastimes = ''
        },
    },
}
</script>
